import React, { useState } from 'react'
import Primaryinput from '../../../components/form/primaryinput'
import Primaryaltbtn from '../../../components/form/primaryaltbtn';
import Functions from './functions';
import { APP_VERSION, BUILD_TIME } from '../../../configTools/version';

const Form = () => {
    const [username,setUsername] = useState('');
    const [password,setPassword] = useState('');
  return (
    <div>
        <div className='public_header_complete colorprimarybg'></div>
        <div className='public_login_wrapper'>
        <div className='public_login_container colorprimarybg'>
            <div className='public_login_form colorsecondarybg'>
                <h3>Login to continue</h3>
                <Primaryinput Lable={'Username'} Type={'text'} Value={username} setInput={setUsername} onkeyPress={(event)=>{
                    if(event.key === 'Enter'){
                        Functions.Submit({
                            username: username,
                            password: password
                        });
                    }
                }}/>
                <Primaryinput Lable={'Password'} Type={'password'} Value={password} setInput={setPassword} onkeyPress={(event)=>{
                    if(event.key === 'Enter'){
                        Functions.Submit({
                            username: username,
                            password: password
                        });
                    }
                }}/>
                <Primaryaltbtn Value={'Login'} Action={()=>{
                    Functions.Submit({
                        username: username,
                        password: password
                    });
                }}/>
                {/* Deliberately readable, not a hidden watermark: this is how a deploy gets
                    confirmed at a glance. BUILD_TIME is injected by the build script, so a
                    stale bundle is obvious even when APP_VERSION has not moved. */}
                <div style={{marginTop:'22px', textAlign:'center', userSelect:'none'}}>
                    <span style={{
                        display:'inline-block', padding:'5px 14px', borderRadius:'14px',
                        backgroundColor:'#ffffff', border:'1px solid #ddd3f2',
                        color:'#5c3da9', fontSize:'14px', fontWeight:700, letterSpacing:'0.5px'
                    }}>v{APP_VERSION}</span>
                    <p style={{
                        marginTop:'7px', fontSize:'11px', color:'#9a9a9a', fontFamily:'monospace'
                    }}>build {BUILD_TIME}</p>
                </div>
            </div>
        </div>
        </div>
    </div>
  )
}

export default Form
